import React from "react";
import FlowioErrorBoundary from "./Container";
import { ReactMarkup } from "../../../globalTypes";

type Config = Partial<{
  inline: boolean;
  withYMargin?: boolean;
  noStretch?: boolean;
}>;

const defaultConfig: Config = {
  inline: false,
  withYMargin: false,
  noStretch: false,
};

const withErrorBoundary = (wrappedMarkup: ReactMarkup, config?: Config) => {
  const combinedConfig = { ...defaultConfig, ...config };

  return (
    <FlowioErrorBoundary {...combinedConfig}>
      {wrappedMarkup}
    </FlowioErrorBoundary>
  );
};

export type WithErrorBoundaryConfig = Config;
export default withErrorBoundary;
